import React from 'react';

const CompetenceSmall = ( {competence} ) => {
    return (
        <div className="competenceSmall">
            <p>{competence}</p>
        </div>
    );
};

export default CompetenceSmall;